import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductionLinesComponent } from 'src/app/components/production-lines/production-lines.component';
import { ProductionLineComponent } from '../../components/production-lines/production-line/production-line.component';
import { InventoryProductionLinesComponent } from '../../components/inventory/production-lines/inventory-production-lines.component';

const routes: Routes = [
  {
    path: '',
    component: ProductionLinesComponent,
    data: {
      breadcrumb: 'Production lines',
    },
    children: [
      {
        path: '',
        component: InventoryProductionLinesComponent,
        data: {
          breadcrumb: undefined, // We use the breadcrumb from the parent
        },
      },
      {
        path: ':id',
        component: ProductionLineComponent,
        data: {
          breadcrumb: 'Production line',
        },
      },
      {
        path: ':id/edit',
        component: ProductionLineComponent,
        data: {
          breadcrumb: 'Edit production line',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductionLineRoutingModule {}
